import { createRoute } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { siteRoute } from '../layouts';

const pages = () => import('./discounts-pages');
const discountsComp = lazyPage(pages, 'DiscountsListHost');
const discountCreateComp = lazyPage(pages, 'DiscountCreateHost');
const discountEditComp = lazyPage(pages, 'DiscountEditHost');

const discountsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/discounts',
  component: discountsComp,
  staticData: { title: 'pricing.discounts' },
});

const discountCreateRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/discounts/create',
  component: discountCreateComp,
  staticData: { title: 'pricing.discount_create' },
});

const discountEditRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'pricing/discounts/edit/$id',
  component: discountEditComp,
  staticData: { title: 'pricing.discount_edit' },
});

/** Discounts sub-group of the pricing family. */
export const discountsLeaves = [discountsRoute, discountCreateRoute, discountEditRoute];
